import React from "react";
import { qhseBg, services71, servicesPrez71 } from "../../../../assets/images";
import { useTranslation } from "react-i18next";
import SubOtherHero from "../../../../Components/Breadcrumb/SubOtherHero/SubOtherHero";

const Coring = () => {
  const { t } = useTranslation();

  return (
    <>
      <div
        className="bg-black/60"
        style={{
          position: "relative",
          overflow: "hidden",
          backgroundImage: `url(${qhseBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          width: "100%",
          height: window.innerWidth < 640 ? "200px" : "300px",
        }}
      >
        <SubOtherHero title="Coring & core analysis" />
      </div>

      <div className="bg-[#EDEDED] py-10 md:py-20">
        <div className="max-w-containerSm md:max-w-container mx-auto ">
          <div className="md:flex md:items-start md:justify-between gap-10 flex-col md:flex-row mt-10">
            <div className="md:w-1/2">
              <p className="mt-6 text-[20px] font-semibold text-[#141615]">
                {t("Coring & core analysis")}
              </p>

              <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B]">
                {t(
                  "Caspian Rock Solutions is a qualified provider of Coring services in Azerbaijan, Turkmenistan, Kazakhstan with experience in the most complex operating and in-place conditions."
                )}
              </p>
              <p className="mt-6 text-[20px] font-semibold text-[#141615]">
                {t("Applied core analysis technologies:")}
              </p>
              <ul className="mt-4 text-[14px] md:text-[20px] text-[#41444B] list-disc list-inside space-y-3">
                <li>{t("Standard core sampling process (Conventional ®)")}</li>
                <li>{t("Hydraulic system Hydro Seat Barrel HALLIBURTON ®")}</li>
                <li>{t("Oriented core sampling (Corienting®)")}</li>
                <li>{t("Full closure System (FCS ®)")}</li>
                <li>{t("Complete closing system (Posiclose®)")}</li>
                <li>
                  {t(
                    "Core sampling using sponge coring crowns with sponges (Sponge coring®)"
                  )}
                </li>
                <li>{t("Core sampling with an insulating agent (Glider®)")}</li>
                <li>{t("Anti-jamming system®")}</li>
              </ul>
              <p className="mt-6 text-[20px] font-semibold text-[#141615]">
                {t("Core Express Analysis Services:")}
              </p>
              <ul className="mt-4 text-[14px] md:text-[20px] text-[#41444B] list-disc list-inside space-y-3">
                <li>{t("High-resolution CT scan")}</li>
                <li>{t("Density of the mineral skeleton")}</li>
                <li>{t("Porosity")}</li>
                <li>{t("Determination of permeability in a steady state")}</li>
                <li>{t("Receiving high-resolution images")}</li>
              </ul>
              <p className="mt-6 text-[20px] font-semibold text-[#141615]">
                {t("Oilfield services")}
              </p>
              <ul className="mt-4 text-[14px] md:text-[20px] text-[#41444B] list-disc list-inside space-y-3">
                <li>{t("Core sorting and processing")}</li>
                <li>{t("Core stabilization")}</li>
                <li>{t("Gamma control of the core")}</li>
                <li>{t("Reservation of the core")}</li>
              </ul>
              <p className="mt-6 text-[20px] font-semibold text-[#141615]">
                {t("Special core analysis services:")}
              </p>
              <ul className="mt-4 text-[14px] md:text-[20px] text-[#41444B] list-disc list-inside space-y-3">
                <li>{t("Wettability by Amott")}</li>
                <li>{t("Residual gas by CCI")}</li>
                <li>{t("Cationic exchange capacity")}</li>
                <li>{t("Parameters of porosity and saturation")}</li>
                <li>{t("Relative permeability")}</li>
                <li>
                  {t(
                    "Determination of capillary pressure by the semipermeable membrane method"
                  )}
                </li>
                <li>
                  {t("Damage of the reservoir, compressibility of pore volume")}
                </li>
              </ul>

              <a
                href={`${servicesPrez71}`}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-[#B31F11] text-white py-2 px-4 rounded-md transition-colors mt-5"
              >
                {t("To learn more information please download datasheet")}
              </a>
            </div>

            {/* Right Image */}
            <div className="md:w-1/2 gap-4 mt-8 md:mt-0">
              <img
                src={services71}
                alt="Drill Bit 1"
                className="w-full rounded-lg shadow-md"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Coring;
